import { getProjectId } from "./functions";

export async function unlockProject(e) {
  const form = new FormData();
  const version = document
    .getElementById("selectedVersion")
    ?.textContent.split(" ")[1];
  form.append(
    "data",
    JSON.stringify({
      function: "unlock_project",
      id: await getProjectId(),
      version,
      removeFlag: false,
    })
  );
  navigator.sendBeacon("./includes/ajax.inc.php", form);
  delete e["returnValue"];
}
